import React from 'react';

interface ContentRuleCenterIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const ContentRuleCenterIcon: React.FC<ContentRuleCenterIconProps> = ({
  width = 64,
  height = 48,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 64 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_34710_12979)'>
        <path
          d='M23.75 32.4998H6.25C5.25544 32.4998 4.30161 32.1047 3.59835 31.4014C2.89509 30.6982 2.5 29.7444 2.5 28.7498V8.74999C2.5 8.41847 2.6317 8.10053 2.86612 7.86611C3.10054 7.63169 3.41848 7.5 3.75 7.5H21.25C21.5815 7.5 21.8995 7.63169 22.1339 7.86611C22.3683 8.10053 22.5 8.41847 22.5 8.74999V23.7498H27.5V28.7498C27.5 29.7444 27.1049 30.6982 26.4017 31.4014C25.6984 32.1047 24.7446 32.4998 23.75 32.4998ZM22.5 26.2498V28.7498C22.5 29.0813 22.6317 29.3993 22.8661 29.6337C23.1005 29.8681 23.4185 29.9998 23.75 29.9998C24.0815 29.9998 24.3995 29.8681 24.6339 29.6337C24.8683 29.3993 25 29.0813 25 28.7498V26.2498H22.5ZM20 29.9998V9.99998H5V28.7498C5 29.0813 5.1317 29.3993 5.36612 29.6337C5.60054 29.8681 5.91848 29.9998 6.25 29.9998H20ZM7.5 13.7499H17.5V16.2499H7.5V13.7499ZM7.5 18.7499H17.5V21.2499H7.5V18.7499ZM7.5 23.7498H13.75V26.2498H7.5V23.7498Z'
          fill='#0000C9'
        />
        <path
          d='M63.9995 0H23.04V3.2569C30.0976 5.54851 35.1999 12.1784 35.1999 19.9999C35.1999 27.8216 30.0976 34.4515 23.04 36.7431V48H63.9995V0Z'
          fill='#E4E9FF'
        />
        <path
          d='M35.1307 21.5775C35.1768 21.0579 35.2004 20.5314 35.2004 20.0001C35.2004 18.9087 35.1004 17.8368 34.9102 16.8H57.6007V21.6002H35.1288C35.1294 21.5923 35.1302 21.5853 35.1307 21.5775Z'
          fill='#CDD6FF'
        />
        <path
          d='M34.0008 26.3999C33.3165 28.1507 32.3585 29.7695 31.1816 31.1952L31.1777 31.1999H54.4008V26.3999H34.0008Z'
          fill='#CDD6FF'
        />
        <path
          d='M33.2817 12H57.6011V8H30.4756C31.5827 9.18751 32.5284 10.5289 33.2755 11.9875C33.2776 11.9914 33.2795 11.9961 33.2817 12Z'
          fill='#CDD6FF'
        />
        <path d='M30.4004 35.2H46.4005V40.0001H30.4004V35.2Z' fill='#CDD6FF' />
      </g>
      <defs>
        <clipPath id='clip0_34710_12979'>
          <rect width='64' height='47.9996' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

ContentRuleCenterIcon.displayName = 'ContentRuleCenterIcon';

export default ContentRuleCenterIcon;
